import initialState from "../initialState";

import {
  SET_INITIAL_USER_TOKEN,
  ERROR_SET_INITIAL_USER_TOKEN,
  USER_LOGGING_IS_LOADED,
  CHANGE_USER_TOKEN_AND_CURRENT_WORKSPACE,
} from "../actions/actionTypes";

export default function configReducer(
  state = initialState.configReducerState,
  action
) {
  switch (action.type) {
    case SET_INITIAL_USER_TOKEN: {
      return {
        ...state,
        userToken: action.userToken,
        initialUserRightHasBeenLoaded: true,
        initialUserRightHasBeenLoadedWithError: false,
      };
    }

    case ERROR_SET_INITIAL_USER_TOKEN: {
      return {
        ...state,
        userToken: "",
        initialUserRightHasBeenLoaded: true,
        initialUserRightHasBeenLoadedWithError: true,
      };
    }

    case USER_LOGGING_IS_LOADED: {
      return {
        ...state,
        userToken: action.userToken,
        currentWorkspace: action.currentWorkspace,
      };
    }

    case CHANGE_USER_TOKEN_AND_CURRENT_WORKSPACE: {
      return {
        ...state,
        userToken: action.userToken,
        currentWorkspace: action.currentWorkspace,
      };
    }

    default: {
      return state;
    }
  }
}
